import AppItemType from "./app";

export const mobileApps: AppItemType[] = [];
